var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M152.009 120C125.499 120 104.009 141.49 104.009 168C104.009 194.51 125.499 216 152.009 216C178.519 216 200.009 194.51 200.009 168C200.009 141.49 178.509 120 152.009 120ZM447.109 32H63.1091C28.6591 32 0 60.65 0 96V416C0 451.35 28.65 480 63.1 480H447.1C482.45 480 511.1 451.35 511.1 416V96C511.109 60.65 483.309 32 447.109 32ZM463.109 409.3L326.309 223.4C323.809 218.8 318.109 216 312.009 216C305.896 216 300.189 218.768 296.799 223.379L190.199 367.479L153.109 321.379C149.668 317.1 144.175 314.57 138.339 314.57C132.497 314.57 127.009 317.099 123.559 321.379L48.0391 415.189C48.0391 415.16 48.0391 415.218 48.0391 415.189L47.9991 96C47.9991 87.178 55.1771 80 63.9991 80H447.999C456.821 80 463.999 87.178 463.999 96V409.3H463.109Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageIcon);
export default __webpack_public_path__ + "static/media/image-icon.e62477757ea304a25072150c6973c73c.svg";
export { ForwardRef as ReactComponent };